export enum Apps {
    lineside =  'lineside',
    conveyance = 'conveyance',
    partsordering = 'partsordering'
}